import { Search } from 'lucide-react'
import clsx from 'clsx'
import type { InputHTMLAttributes } from 'react'

interface SearchInputProps extends InputHTMLAttributes<HTMLInputElement> {
  onSearch?: (value: string) => void
}

export default function SearchInput({ className, onSearch, onChange, ...props }: SearchInputProps) {
  return (
    <div className={clsx('relative', className)}>
      <Search className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
      <input
        type="text"
        className="h-11 w-full rounded-lg border border-gray-300 bg-transparent pl-11 pr-4 py-2.5 text-sm text-gray-800 shadow-xs placeholder:text-gray-400 focus:border-brand-300 focus:ring-3 focus:ring-brand-500/10 focus:outline-none transition-colors"
        onChange={e => {
          onChange?.(e)
          onSearch?.(e.target.value)
        }}
        {...props}
      />
    </div>
  )
}
